export function iframe(url){

    return dispatch => {     
   return `<div class="embed-responsive embed-responsive-16by9">
                        <iframe 
                            class       = "embed-responsive-item"
                            src         = '${url}'
                            height      = "500"
                            width       = "783"
                            frameborder = "0"
                            style       = "border:none;
                            allowfullscreen ">
                        </iframe>
                    </div>`;
    }
    }


// WEBPACK FOOTER //
// ./src/actions/jogosAction.js